import { RouteConfig } from 'vue-router'
import { PopUpRouteConfig } from '@/shared/types/basePopUp'
import { cashOutOrderEndpoint } from '@/modules/order-management/cashout-order'
import { cashOutPreviewComponents } from '@/modules/order-management/cashout-order/helpers/previewCashoutOrder'
import CancelCashoutOrder from '@/modules/order-management/cashout-order/components/CancelCashoutOrder.vue'

/**
 * cashout module routes
 */
export const cashOutRoutes: RouteConfig[] = [
  {
    path: '/cashout',
    name: 'cashout',
    component: () =>
      import(
        /* webpackChunkName: "TheCashoutOrderChunk" */ '@/modules/order-management/cashout-order/views/TheCashoutOrder.vue'
      ),
    meta: {
      title: 'navigations.cashoutMetaTitle',
      parentRouteName: null
    }
  },
  {
    path: '/cashout/preview-details/:id',
    name: 'preview-cashout',
    component: () =>
      import(
        /* webpackChunkName: "TheCashoutOrderPreviewChunk" */ '@/modules/order-management/cashout-order/views/TheCashoutPreview.vue'
      ),
    meta: {
      title: 'navigations.cashoutMetaTitle',
      parentRouteName: 'cashout',
      logPage: {
        endpoint: cashOutOrderEndpoint,
        previewDynamicComponents: cashOutPreviewComponents
      }
    }
  },
  {
    path: '/cashout/upsert/:id?',
    name: 'upsert-cashout',
    component: () =>
      import(
        /* webpackChunkName: "TheCashoutOrderUpsertChunk" */ '@/modules/order-management/cashout-order/views/TheCashoutUpsert.vue'
      ),
    meta: {
      title: 'navigations.cashoutMetaTitle',
      parentRouteName: 'cashout'
    }
  },
  {
    path: '/cashout/review/:id',
    name: 'review-cashout',
    component: () =>
      import(
        /* webpackChunkName: "TheCashoutOrderReviewChunk" */ '@/modules/order-management/cashout-order/views/TheCashoutReview.vue'
      ),
    meta: {
      title: 'navigations.cashoutMetaTitle',
      parentRouteName: 'cashout'
    }
  }
]

export const cashOutModalRoute: PopUpRouteConfig[] = [
  {
    component: CancelCashoutOrder,
    persistent: false,
    name: 'cancel-cashout',
    requiredParams: ['id']
  }
]
